import * as Yup from "yup";

export const onestopFlagSchema = (
  isHometownTax: boolean,
  onestopDeliverable: boolean
) =>
  isHometownTax && onestopDeliverable
    ? Yup.boolean().required("必須項目です").defined()
    : Yup.boolean().nullable();
